import { Accordion, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';


import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import AddEditOffer from "./AddEditOffer";

export default function OfferList() {
    let today = Date.now();
    today = new Date(today).setHours(0, 0, 0, 0);
    let fifteenDaysAgo = new Date(today - 15 * 24 * 60 * 60 * 1000).getTime();
    let fifteenDaysFuture = new Date(today + 15 * 24 * 60 * 60 * 1000).getTime();


    const [offers, setOffers] = useState([]);
    const [fromDate, setFromDate] = useState(moment(fifteenDaysAgo).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(moment(fifteenDaysFuture).format("YYYY-MM-DD"));
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [showAddEditOfferModal, setShowAddEditOfferModal] = useState(false);

    const getOffers = useQuery("offers", async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/offer/v2/?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 59)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setOffers(data?.data || []);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const offerDeleteMutation = useMutation((body) => axios.delete(`${DEV_SERVER}/offer/v2/${body.id}`, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success("Offer deleted successfully")
                refetchOffers()
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleFilters = async () => {

        await refetchOffers();
    }

    const refetchOffers = () => {
        getOffers.refetch({ cancelRefetch: true });
    }

    const ExpandedComponent = ({ data }) => {
        console.log("data ", data)
        return (

            <Card>
                <Card.Header>
                    <h4>{data?.name}</h4>
                </Card.Header>

                <Card.Body>
                    <div className="d-flex flex-column">
                        <span className="position-relative" style={{ width: "100%" }}>
                        <img src={data?.banner} alt="banner" className="mx-5" style={{ width: "100%", maxHeight: "200px" }} />
                        <span className="badge bg-success" style={{position: "absolute",top: "-10%", right: '-2%'}}>Active</span>
                        </span>
                        <div className="d-flex justify-content-between">

                            <span className="d-flex flex-column mt-3">
                                <p><b>Offer Duration:</b> {moment(data?.startTime).format("DD-MM-YYYY")} - {moment(data?.endTime).format("DD-MM-YYYY")}</p>
                            </span>

                            <span className="d-flex flex-column mt-3">
                                <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Edit</Tooltip>}>
                                        <span style={{ cursor: "pointer" }} onClick={() => {
                                            setSelectedOffer(data);
                                            setShowAddEditOfferModal(true);
                                        }}><i className="far fa-edit table-icons"></i></span>
                                    </OverlayTrigger>
                                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Delete</Tooltip>}>
                                        <span style={{ cursor: "pointer" }} onClick={() => {
                                            confirmAlert({
                                                title: 'Confirm to delete',
                                                message: 'Are you sure you want to delete this offer?',
                                                buttons: [
                                                    {
                                                        label: 'Yes',
                                                        onClick: () => {
                                                            offerDeleteMutation.mutate({ id: data?.id });
                                                        }
                                                    },
                                                    {
                                                        label: 'No',
                                                        onClick: () => { }
                                                    }
                                                ],
                                                overlayClassName: "overlay-custom-confirm-alert",
                                            });
                                        }}><i className="far fa-trash-alt table-icons"></i></span>
                                    </OverlayTrigger>
                                </div>
                            </span>
                        </div>
                    </div>

                </Card.Body >
            </Card >



        )
    }

    useEffect(() => {
        refetchOffers();
    }, [])

    console.log("offers ", offers)

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Offer List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>

                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Filters</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", rowGap: "0.7rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" defaultValue={fromDate} onChange={(e) => {
                                                        setFromDate(e.target.value)

                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" defaultValue={toDate} onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }} />
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setFromDate(moment(fifteenDaysAgo).format("YYYY-MM-DD"));
                                                    setToDate(moment(fifteenDaysFuture).format("YYYY-MM-DD"));

                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>

                                <div className="d-flex align-items-end justify-content-end mt-3">
                                    <button onClick={() => {
                                        setSelectedOffer(null);
                                        setShowAddEditOfferModal(true);
                                    }} className="btn btn-primary">
                                        <i className="fas fa-plus"></i>
                                        <span className="ms-1">Add Offer</span>
                                    </button>
                                </div>

                                {(!getOffers.isLoading && !getOffers?.isFetching) &&

                                    <div className="d-flex flex-column px-5" style={{ rowGap: "1rem" }}>
                                        {offers.map((item, i) => {
                                            return <ExpandedComponent key={i} data={item} />
                                        })}
                                    </div>
                                }
                                {getOffers.isLoading || getOffers?.isFetching && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>

            {showAddEditOfferModal && <AddEditOffer show={showAddEditOfferModal} refetchOffers={refetchOffers} close={() => setShowAddEditOfferModal(false)} offer={selectedOffer} />}
        </>
    )
}